export default __webpack_public_path__ + "static/card-fd175299f83fd891798c1b23d2b0d5bc.png";